import 'whatwg-fetch';
import API, { GET_AUTH_ROOMS } from 'base/api';
import auth from 'base/auth';

export const FETCH_ROOM_DATA = 'FETCH_ROOM_DATA';
export const FETCH_ROOM_DATA_BEGIN = 'FETCH_ROOM_DATA_BEGIN';
export const FETCH_ROOM_DATA_SUCCESS = 'FETCH_ROOM_DATA_SUCCESS';
export const FETCH_ROOM_DATA_ERROR = 'FETCH_ROOM_DATA_ERROR';

export const fetchRoomDataBegin = () => ({
    type: FETCH_ROOM_DATA_BEGIN
});

export const fetchRoomDataSuccess = ( data ) => ({
    type: FETCH_ROOM_DATA_SUCCESS,
    payload: { data }
});

export const fetchRoomDataError = ( error ) => ({
    type: FETCH_ROOM_DATA_ERROR,
    payload: { error }
});

export function fetchRoomData (id){
    return dispatch => {
      dispatch(fetchRoomDataBegin());
      return fetch(API.GET_ROOM_DATA + id, GET_AUTH_ROOMS)
        .then(handleErrors)
        .then(res => res.json())
        .then(json => {
          dispatch(fetchRoomDataSuccess(json));
          auth.setActualRoom(id);
          return json;
        })
        .catch(error => dispatch(fetchRoomDataError(error.message)));
    };
  }

  function handleErrors(response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  }


// WEBPACK FOOTER //
// ./src/modules/User/redux/fetchRoomData.js